
// Packages
import axios from "axios";

const deleteExamDate = (examdate_id, refreshHook) => {
    /* 
        params:
            examdate_id: int;
                - db id of examdate
            refreshHook: function passed down used to refresh calendar component
    */

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const token = localStorage.getItem("access_token");

    //axios call to Django view
    axios
    .delete(`${process.env.REACT_APP_API_BASE_URL}api/delete-exam-date/${examdate_id}/`, 
        {
            headers : {
                Authorization: `Bearer ${token}`
            }
    })
    .then((response) => {
        if (response.status === 204) {
            refreshHook();
        }
    })
    .catch((error) => {
        console.log(error)
    });
}

export default deleteExamDate;